var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',{attrs:{"config":_vm.configLabels}},[_vm._l((_vm.mapLabels.text),function(label){return _c('v-text',{key:((label.text) + " text base"),attrs:{"config":{
      text: label.text,
      x: label.x,
      y: label.y,
      rotation: label.rotation || 0,
      fontSize: label.textType.fontSize,
      fontFamily: label.textType.fontFamily,
      fill: label.textType.fill,
      align: 'left',
      width: label.width,
      shadowEnabled: true,
      shadowColor: '#f4f4f4',
      shadowOffset: { x: 2, y: 2 },
      shadowBlur: 5,
    }}})}),_vm._l((_vm.mapLabels.text),function(label){return _c('v-text',{key:((label.text) + " text highlight"),attrs:{"config":{
      text: label.text,
      x: label.x,
      y: label.y,
      rotation: label.rotation || 0,
      fontSize: label.textType.fontSize,
      fontFamily: label.textType.fontFamily,
      fill: '#ffffff',
      opacity: 0,
      align: 'left',
      width: label.width,
      shadowEnabled: true,
      shadowColor: 'rgba(0, 0, 0, 1)',
      shadowOffset: { x: 2, y: 2 },
      shadowBlur: 5,
    }},on:{"mouseenter":_vm.addHighlight,"mouseleave":_vm.removeHighlight}})}),_vm._l((_vm.mapLabels.textPath),function(label){return _c('v-text-path',{key:((label.text) + " text-path base"),staticClass:"path",attrs:{"config":{
      text: label.text,
      x: label.x,
      y: label.y,
      data: label.data,
      rotation: label.rotation || 0,
      fontSize: label.textType.fontSize,
      fontFamily: label.textType.fontFamily,
      fill: label.textType.fill,
      align: 'justify',
      shadowEnabled: true,
      shadowColor: '#f4f4f4',
      shadowOffset: { x: 2, y: 2 },
      shadowBlur: 5,
    }}})}),_vm._l((_vm.mapLabels.textPath),function(label){return _c('v-text-path',{key:((label.text) + " text-path highlight"),attrs:{"config":{
      text: label.text,
      x: label.x,
      y: label.y,
      data: label.data,
      rotation: label.rotation || 0,
      fontSize: label.textType.fontSize,
      fontFamily: label.textType.fontFamily,
      fill: '#ffffff',
      opacity: 0,
      align: 'justify',
      shadowEnabled: true,
      shadowColor: 'rgba(0, 0, 0, 1)',
      shadowOffset: { x: 2, y: 2 },
      shadowBlur: 5,
    }},on:{"mouseenter":_vm.addHighlight,"mouseleave":_vm.removeHighlight}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }